export class EquipmentOptionDto {
  id?: number;
  option?: string | null;
}
